import { useEffect, useRef } from "react";
import "../../../../assets/UFC_DC_RF_V1/scss/modules/referral.scss";

export default function ReferralFee({ close }) {
  const btnRef = useRef(null);

  useEffect(() => {
    if (btnRef) {
      btnRef.current.scrollIntoView();
    }
  }, [btnRef]);
  return (
    <div
      className="modal fade show"
      id="exampleModalLive"
      tabIndex={-1}
      aria-labelledby="exampleModalLiveLabel"
      aria-modal="true"
      role="dialog"
      style={{ display: "block" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text-end mb-2">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={close}
              />
            </div>
            <div className="content-body">
              <p>
                We believe in transparency. In some cases, where we introduce a
                client to a trusted third party — such as Charterhouse Claims —
                we may receive a referral fee.
              </p>
              <p>
                This fee is paid to us by Charterhouse Claims directly and does
                not affect the amount of compensation you may be entitled to or
                the service you receive. It simply reflects a collaboration
                between our organisations to help more people seek redress.
              </p>
              <p>
                These arrangements are typical in the legal and claims sectors
                and are designed to ensure our partner is fairly compensated for
                taking on your claim, while we can continue to support access to
                justice at scale. On the notion, there is a successful outcome
                on your behalf, we will be remunerated 60% of cleared/banked
                redress net of VAT.
              </p>
              <p>
                If you would like more information about this arrangement, you
                can contact us.
              </p>
              <div className="col-md-9 col-sm-12 col-12 m-auto">
                <button
                  type="button"
                  className="okay-btn"
                  aria-label="Close"
                  onClick={close}
                  ref={btnRef}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
